import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { AmountInfo } from '../../api/types'
import AppContext from '../../app/context'
import buildStyles from './styles'
import cx from 'classnames'
import { setAmount } from '../../app/context/actions'
import { useWindowSize } from '../../hooks/useWindowSize'
import { MOBILE_WIDTH_HIGH } from '../../constants/constants'

interface AmountBlockProps {
  amount: AmountInfo
  setOpenPopup?: (status: boolean) => void
}

const AmountBlock = ({ amount, setOpenPopup }: AmountBlockProps) => {
  const { state, contextDispatch } = useContext(AppContext)
  const navigate = useNavigate()
  const screen = useWindowSize()
  const isMobile: boolean = (screen.width as number) < MOBILE_WIDTH_HIGH
  const styles = buildStyles({ isMobile: isMobile })

  const handleClick = () => {
    setAmount(contextDispatch, amount)

    if (
      state.locationConfig &&
      state.selectedOrganization &&
      state.selectedGoal
    ) {
      if (state.rules.length > 0) {
        navigate(
          `/${state.locationConfig.locationCode}/${state.selectedOrganization.id}/${state.selectedGoal.id}/regulamin`
        )
      } else {
        navigate(
          `/${state.locationConfig.locationCode}/${state.selectedOrganization.id}/${state.selectedGoal.id}/potwierdzenie`
        )
      }
    }
  }

  const handleOtherClick = () => {
    setOpenPopup && setOpenPopup(true)
  }

  return (
    <>
      {amount.value === 'other' && (
        <div className={styles.optionCard} onClick={handleOtherClick}>
          <span
            style={{ fontSize: isMobile ? '28px' : '38px' }}
            className={styles.optionLabel}
          >
            {amount.txt}
          </span>
        </div>
      )}
      {amount.value !== 'other' && (
        <div className={cx(styles.optionCard)} onClick={handleClick}>
          <span
            style={{ fontSize: isMobile ? '28px' : '38px' }}
            className={styles.optionLabel}
          >
            {amount.txt}
          </span>
        </div>
      )}
    </>
  )
}

export default AmountBlock
